/**
 * Phone number formatting utilities
 */

/**
 * Format phone number for display
 * Examples:
 *   +12345678901 -> (234) 567-8901
 *   2345678901 -> (234) 567-8901
 *   (234) 567-8901 -> (234) 567-8901 (already formatted)
 */
export function formatPhoneDisplay(phone: string | undefined): string {
  if (!phone) return "";

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, "");

  // Handle different lengths
  if (digits.length === 11 && digits.startsWith("1")) {
    // US number with country code: +12345678901
    const areaCode = digits.slice(1, 4);
    const prefix = digits.slice(4, 7);
    const lineNumber = digits.slice(7);
    return `(${areaCode}) ${prefix}-${lineNumber}`;
  } else if (digits.length === 10) {
    // US number without country code: 2345678901
    const areaCode = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const lineNumber = digits.slice(6);
    return `(${areaCode}) ${prefix}-${lineNumber}`;
  }

  // If it doesn't match expected format, return original
  return phone;
}

/**
 * Format phone number for tel: link
 * Examples:
 *   (234) 567-8901 -> +12345678901
 *   2345678901 -> +12345678901
 *   +12345678901 -> +12345678901 (already formatted)
 */
export function formatPhoneTel(phone: string | undefined): string {
  if (!phone) return "";

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, "");

  // Add +1 country code if not present
  if (digits.length === 10) {
    return `+1${digits}`;
  } else if (digits.length === 11 && digits.startsWith("1")) {
    return `+${digits}`;
  }

  // If already has +, return as-is
  if (phone.startsWith("+")) {
    return phone.replace(/\D/g, "").replace(/^/, "+");
  }

  return `+${digits}`;
}
